// The filters of the client's matching page, as the Ready to Hire tab holds them. Skills and the technical
// languages belong to one role.
export const emptyReadyToHireFilters = () => ({
  seniority_level: null,
  industry: null,
  primary_technical_language: null,
  secondary_technical_language: null,
  skills: [],
  countries: [],
  availability: [],
  language: null,
  language_level: null,
  qualified: false,
});

// The availability ticks, each with the key of its count in the filter-counts response
export const READY_TO_HIRE_AVAILABILITIES = [
  { id: "full_time", name: "Full-time", count: "full_time_count" },
  { id: "part_time", name: "Part-time", count: "part_time_count" },
  { id: "undefined", name: "Not defined", count: "undefined_count" },
];

// As query parameters. axios 0.19 sends an array as key[] but an object as JSON, so the language goes as two
// keys; Laravel's boolean rule takes 1, not "true". Unset values are left out.
export const readyToHireFilterParams = (filters) => ({
  seniority_level: filters.seniority_level || undefined,
  industry: filters.industry || undefined,
  primary_technical_language: filters.primary_technical_language || undefined,
  secondary_technical_language:
    filters.secondary_technical_language || undefined,
  skills: filters.skills,
  countries: filters.countries,
  availability: filters.availability,
  "language[name]": filters.language || undefined,
  "language[level]": (filters.language && filters.language_level) || undefined,
  qualified: filters.qualified ? 1 : undefined,
});

// How many filters are set; a language and its level count as one
export const countReadyToHireFilters = (filters) =>
  Object.entries(readyToHireFilterParams(filters)).filter(
    ([key, value]) =>
      key !== "language[level]" &&
      (Array.isArray(value) ? value.length > 0 : value !== undefined)
  ).length;
